export default function getStatusBadgeColor(status) {
  switch (status) {
    case 'PENDING':
      return 'amber';
    case 'INFORCE':
      return 'emerald';
    case 'EXPIRED':
    case 'CANCELLED':
    default:
      return 'slate';
  }
}
